import { ApiApi, Assessment } from '@api';
import { CookieHelper, ErrorHelper } from '@helpers';
import { AssessmentsEnum } from '@sections/ModelInventoryTable/types';
import { notificationsStore, questionnaireStore } from '@stores';
import { AppRoutes } from '@types';
import { toast } from 'react-toastify';
import { ASSESSMENTS_IDS_KEY } from 'src/pages/questionnaire/data-collection';

export const handleAssessment = async (
  questionnaireAnswer: number,
  api: ApiApi,
  push,
  setCompleted,
  setIsLongAssessment,
  setSubmitting,
  onSettled?: () => void,
) => {
  try {
    if (!questionnaireAnswer) {
      return;
    }
    const { updateNotifications } = notificationsStore;
    const { selectedRiskMetrics } = questionnaireStore;

    const response = await api.apiAssessmentsCreate({
      assessment: {
        questionnaireAnswer,
        riskMetrics: selectedRiskMetrics.map(riskMetric => riskMetric.id),
        quick: false,
      } as Assessment,
    }); // trigger assessment creation

    if (response.status === AssessmentsEnum.pending || response.status === AssessmentsEnum.running) {
      setCompleted(true);
      push(`${AppRoutes.dataCollection}#completed`, undefined, { shallow: true });
      const timeoutInterval = setTimeout(() => {
        setIsLongAssessment(true); // if assessment is longer then 32 seconds
      }, 32000);

      updateNotifications(api);
      // logic if user leaves the app => show notification on next visit to platform (save assessments in cookie)
      const runningAssessments = JSON.parse(CookieHelper.get(ASSESSMENTS_IDS_KEY) || '[]');
      CookieHelper.set(ASSESSMENTS_IDS_KEY, JSON.stringify([...runningAssessments, response.id]));

      const interval = setInterval(async () => {
        const hasAssassment = await api.apiAssessmentsRetrieve({
          id: response.id,
        });

        if (hasAssassment.status !== AssessmentsEnum.running && hasAssassment.status !== AssessmentsEnum.pending) {
          // remove assessment from list of async running assessments
          const assessments = JSON.parse(CookieHelper.get(ASSESSMENTS_IDS_KEY) || '[]');
          CookieHelper.set(
            ASSESSMENTS_IDS_KEY,
            JSON.stringify(assessments.filter(assessment => assessment !== response.id)),
          );

          setTimeout(() => updateNotifications(api), 5000);
          if (hasAssassment.status === AssessmentsEnum.success) {
            toast.success('Assessment is successfully finished!');
          }
          if (hasAssassment.status === AssessmentsEnum.successWithErrors) {
            toast.success('Assessment is successfully finished with errors!');
          }
          if (hasAssassment.status === AssessmentsEnum.failed) {
            toast.error('Assessment has failed. Please check your answers and submit questionnaire form again.');
          }

          if (window.location.hash === '#completed') {
            push(`${AppRoutes.assessmentInventory}/${response.id}`);
          }
          clearInterval(interval);
          clearInterval(timeoutInterval);
        }
      }, 10000);
    }
    setCompleted(true);
    setSubmitting(false);
    onSettled?.();
  } catch (error) {
    ErrorHelper.handleErrorNotification(error);
    setSubmitting(false);
    onSettled?.();
  }
};
